/*
 *
 * SignUpPage
 *
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { signUpRequest, resendVerificationRequest } from "./actions";
import { ToastContainer, toast } from "react-toastify";
import { selectSignUpSuccessful, selectSignUpEmail, selectVerificationResent } from './selectors';
import {
  Wrapper,
  Container,
  Heading,
  ButtonGroup,
  A,
} from './styledComponents';
import Form from './Form';

import { setModal } from 'containers/RootModal/actions';
import {
  INVALID_EMAIL,
  INVALID_PASSWORD,
  PASSWORD_REQUIREMENTS,
  VERIFICATION_RESENT_SUCCESS_MODAL,
} from "containers/RootModal/constants";
import H1 from 'components/H1';
import Button from 'components/Button';

const notify = () => toast('Verification email sent!');

class SignUpPage extends Component {

  componentDidUpdate(prevProps) {
    const { verificationResent } = this.props;
    if ( prevProps.verificationResent === false && verificationResent ) {
       notify();
    }
  }

  render() {
    const {
      resendVerification,
      onSignUpSubmit,
      openInvalidEmailModal,
      openInvalidPasswordModal,
      openPasswordRequirementsModal,
      signUpSuccessful,
      signUpEmail
    } = this.props;


    return (
    <Wrapper>
      <Helmet title='Movebooth | Self Sign Up' />
      <ToastContainer />
      {signUpSuccessful
        ?
          <Container>
            <Heading email>
              <H1>
                Verify your email.
              </H1>
              We need to verify your email address for you to access your account.
              If you haven’t received an email with a verification link,&nbsp;
              <A href='#'
                onClick={() => resendVerification({email: signUpEmail})}>
                request another email.
              </A>
            </Heading>
            <ButtonGroup>
              <Link to='/sign-in'>
                <Button>
                    Go to Sign In
                </Button>
              </Link>
            </ButtonGroup>
          </Container>
        :
          <Container>
            <Heading>
              <H1>
              Get the photo booth that moves you… and your business.
              </H1>
              <p>
                Sign up for a 14-day FREE trial of Movebooth Pro. After that,
                our plans start at just $90 per month.
              </p>
            </Heading>
            <Form
              onSubmit={onSignUpSubmit}
              openInvalidEmailModal={openInvalidEmailModal}
              openInvalidPasswordModal={openInvalidPasswordModal}
              openPasswordRequirementsModal={openPasswordRequirementsModal}
            />
          </Container>
      }
    </Wrapper>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  signUpSuccessful: selectSignUpSuccessful(),
  signUpEmail: selectSignUpEmail(),
  verificationResent: selectVerificationResent(),
});

const mapDispatchToProps = (dispatch) => ({
  onSignUpSubmit: (data) => dispatch(signUpRequest(data)),

  resendVerification: (email) => dispatch(resendVerificationRequest(email)),

  openInvalidEmailModal: () => dispatch(setModal({ modalType: INVALID_EMAIL })),

  openVerificationResentSuccessModal: () =>
    dispatch(setModal({ modalType: VERIFICATION_RESENT_SUCCESS_MODAL })),

  openPasswordRequirementsModal: () =>
    dispatch(setModal({ modalType: PASSWORD_REQUIREMENTS })),

  openInvalidPasswordModal: (modalProps) =>
    dispatch(setModal({ modalType: INVALID_PASSWORD, modalProps })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);



// WEBPACK FOOTER //
// ./src/containers/SelfSignUp/index.js